var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditOutlined2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 3,
    fill: "#272727"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34245 4.02313L7.97755 4.65823M7.75075 3.46363L6.03265 5.18173C5.94388 5.27038 5.88333 5.38332 5.85865 5.50633L5.69995 6.30073L6.49435 6.14173C6.61735 6.11713 6.73015 6.05683 6.81895 5.96803L8.53705 4.24993C8.58868 4.1983 8.62964 4.13701 8.65758 4.06955C8.68552 4.00209 8.6999 3.92979 8.6999 3.85678C8.6999 3.78376 8.68552 3.71146 8.65758 3.64401C8.62964 3.57655 8.58868 3.51526 8.53705 3.46363C8.48542 3.412 8.42413 3.37105 8.35667 3.3431C8.28922 3.31516 8.21692 3.30078 8.1439 3.30078C8.07089 3.30078 7.99859 3.31516 7.93113 3.3431C7.86367 3.37105 7.80238 3.412 7.75075 3.46363Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09985 6.90039V7.80039C8.09985 7.95952 8.03664 8.11213 7.92412 8.22465C7.8116 8.33718 7.65898 8.40039 7.49985 8.40039H4.19985C4.04072 8.40039 3.88811 8.33718 3.77559 8.22465C3.66307 8.11213 3.59985 7.95952 3.59985 7.80039V4.50039C3.59985 4.34126 3.66307 4.18865 3.77559 4.07613C3.88811 3.9636 4.04072 3.90039 4.19985 3.90039H5.09985",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutlined2);
export default __webpack_public_path__ + "static/media/EditOutlined2.a6ec494a4004e9a3349b4468b65ab4bd.svg";
export { ForwardRef as ReactComponent };